export default __webpack_public_path__ + "static/media/LOGOBUBLEWHITECRI.d5641ef9.png";